import React from "react";
import "./PolicyPages.css";

const Shipping = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <h1>Shipping and Delivery Policy</h1>
        <p className="policy-date">Last Updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>Digital Services Delivery</h2>
          <p>
            As an IT and software services company, Vero Disruptors primarily delivers digital services 
            and products. Our delivery methods include:
          </p>
          <ul>
            <li>Secure file transfers via encrypted channels</li>
            <li>Cloud-based deployment and access</li>
            <li>Direct downloads from our secure servers</li>
            <li>Access credentials for web-based applications</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Delivery Timeframes</h2>
          <p>
            Delivery timeframes vary based on the type of service or product:
          </p>
          <div className="delivery-timelines">
            <div className="timeline-item">
              <h3>Software Development Projects</h3>
              <p>Delivery timelines are specified in individual project contracts, typically ranging from 2 weeks to 6 months depending on project complexity.</p>
            </div>
            <div className="timeline-item">
              <h3>Consulting Services</h3>
              <p>Consulting sessions are scheduled upon payment confirmation, usually within 2-5 business days.</p>
            </div>
            <div className="timeline-item">
              <h3>Digital Products</h3>
              <p>Access to digital products is provided immediately upon successful payment processing.</p>
            </div>
          </div>
        </section>

        <section className="policy-section">
          <h2>Physical Products (If Applicable)</h2>
          <p>
            In cases where physical products are involved (such as hardware or documentation), the following 
            shipping policies apply:
          </p>
          <ul>
            <li><strong>Shipping Methods:</strong> We use reputable courier services including DHL, FedEx, and local delivery partners</li>
            <li><strong>Shipping Charges:</strong> Calculated based on weight, destination, and delivery speed</li>
            <li><strong>International Shipping:</strong> Available to most countries with additional customs and duty charges</li>
            <li><strong>Tracking:</strong> All shipments include tracking information sent to your email</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Delivery Confirmation</h2>
          <p>
            For digital services, delivery is confirmed via:
          </p>
          <ul>
            <li>Email notification with access instructions</li>
            <li>Project completion reports</li>
            <li>Client acceptance sign-off</li>
            <li>Invoice marked as "delivered"</li>
          </ul>
          <p>
            For physical products, delivery is confirmed by the courier service's tracking system.
          </p>
        </section>

        <section className="policy-section">
          <h2>Delivery Issues</h2>
          <p>
            In case of delivery issues, please contact us immediately:
          </p>
          <ul>
            <li><strong>Failed Digital Delivery:</strong> Contact us within 24 hours of expected delivery</li>
            <li><strong>Damaged Physical Products:</strong> Report within 48 hours of receipt with photographs</li>
            <li><strong>Wrong Item Delivered:</strong> Notify us immediately for replacement</li>
            <li><strong>Lost Shipments:</strong> File claim within 7 days of expected delivery date</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Installation and Setup Support</h2>
          <p>
            For software products, we provide:
          </p>
          <ul>
            <li>Comprehensive installation guides</li>
            <li>Technical support during initial setup</li>
            <li>Remote assistance if required</li>
            <li>Training sessions as specified in service agreements</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Regional Delivery Restrictions</h2>
          <p>
            Some services may have regional restrictions due to:
          </p>
          <ul>
            <li>Local regulations and compliance requirements</li>
            <li>Technical infrastructure limitations</li>
            <li>Export control laws</li>
            <li>Service availability in specific regions</li>
          </ul>
          <p>
            We will notify you during the ordering process if any restrictions apply to your location.
          </p>
        </section>

        <section className="policy-section contact-section">
          <h2>Contact for Delivery Inquiries</h2>
          <div className="contact-info">
            <p><strong>Delivery Support Email:</strong> support@verodisruptors.com</p>
            <p><strong>Phone:</strong> +91 9032584791</p>
            <p><strong>Business Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM IST</p>
            <p>
              <strong>Address:</strong> PH.No: 3-06-1, Thimmanapalem
Korisapadu (MD), Bapatla (DT)
Andhra Pradesh - 523212
India
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Shipping;